// WebSite.js
import React from "react";

const WebSite = () => {
  const links = {
    es: "https://www.nisibygiuseppe.com/",
  };

  return (
    <a
      href={links.es}
      target="_blank"
      rel="noopener noreferrer"
      className="button-styles hover-text"
    >
      <span className="tooltip-text" id="fade">Web Site</span>
      <i className="bi bi-globe-americas"></i>
    </a>
  );
};

export default WebSite;
